var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[(!(_vm.opened&&_vm.$route.path == '/homePage'))?_c('Sildebar'):_vm._e(),_c('el-container',[_c('el-header',[_c('Header')],1),_c('el-main',{class:{ homePage: _vm.$route.path == '/homePage' }},[_c('Content')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }